import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MyTeamService } from '../my-team.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RejectionReasonModel } from 'src/app/models/common/myteam-model';

@Component({
  selector: 'logzy-user-rejection-reason',
  templateUrl: './user-rejection-reason.component.html',
  styleUrls: ['./user-rejection-reason.component.scss']
})
export class UserRejectionReasonComponent implements OnInit {

  @Output() rejectReasonSaved = new EventEmitter<void>();

  disableSave: boolean = false;

  @Input() loading: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UserRejectionReasonComponent>,
    private myTeamService: MyTeamService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog) { }

  set: boolean = false;
  email: string = '';
  rejectionReasonList: RejectionReasonModel[] = [];
  selectedReason: RejectionReasonModel = null;
  errorObj: any = {};

  ngOnInit(): void {
    this.email = this.data.email;
    this.getRejectionReasons();
  }

  getRejectionReasons() {
    this.myTeamService.getRejectionReason().subscribe(res => {
      console.log(res);
      this.rejectionReasonList = res.results;
    })
  }

  rejectUser() {
    console.log(this.selectedReason);
    this.disableSave = true;
    this.myTeamService.rejectTeamMember({ email: this.email, rejection_reason: this.selectedReason }).subscribe({
      next: res => {
        this.disableSave = false;
        this.closeDialog();
        this.rejectReasonSaved.emit();
      },
      error: err => {
        this.disableSave = false;
        return this.catchError(err);
      }
    })
  }

  closeDialog() {
    this.dialogRef.close(false)
  }

  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    }
  }
}
